module.exports = __webpack_public_path__ + "static/main_bg-9edfbf3675120c93c38a8716ae22406f.svg";